import React from 'react';
import RegistrationBox from '../../components/auth/RegistrationBox';

const Registration: React.FC = () => {
  return (
    <main className="registration-page">
      <RegistrationBox />
    </main>
  );
};

export default Registration;
